import { Alert } from "antd";
import { toast } from "react-toastify";

import Loading from "@/components/Loading";
import { useUpdateURLSearchParams } from "@/hooks/useQuery";
import useSearchParams from "@/hooks/useSearchParams";
import { useDeleteCustomerFields } from "@/queries/customerFields/useDeleteCustomerField";
import Modal from "@/ui/Modal";

export const DeleteCustomFieldsModal = () => {
  const searchParams = useSearchParams();
  const updateParams = useUpdateURLSearchParams();

  const { deleteCustomerField, isLoading, isError } = useDeleteCustomerFields();

  const customerFieldId = String(searchParams.get("deleteId") || "");

  const onConfirm = () => {
    deleteCustomerField(customerFieldId)
      .then(() => {
        updateParams(["deleteId", undefined]);
        toast.success("Custom field deleted");
      })
      .catch((error) => {
        toast.error("Error deleting custom field");
        throw error;
      });
  };

  return (
    <Modal
      open
      cancelButtonProps={{
        disabled: isLoading,
      }}
      okButtonProps={{
        disabled: isLoading,
        className: "ml-2",
        danger: true,
      }}
      okText="Delete"
      onCancel={() => updateParams(["deleteId", undefined])}
      onOk={() => onConfirm()}
      title="Delete Custom Field"
      width={{
        xs: "90%",
        sm: "80%",
        md: "70%",
        lg: "50%",
        xl: "40%",
        xxl: "30%",
      }}
    >
      {isLoading && <Loading className="!h-48" />}

      {!isLoading && isError && <p>This custom field doesn't exist.</p>}

      {!isLoading && !isError && (
        <Alert
          showIcon
          className="my-4"
          description="Deleting this field deletes all data stored in this field."
          message="Are you sure you want to delete the custom field?"
          type="warning"
        />
      )}
    </Modal>
  );
};
